export class Filter {
  field: string
  value: string | number | boolean

  constructor(field: string,  value: string | number) {
    this.field = field
    this.value = value
  }
}
